<div class="privacy-policy">
  <div class="bg-image">
    <img src="assets/images/sigin.webp" alt="Background">
  </div>

  <nav class="navbar">
    <img src="assets/images/logo-light.svg" alt="Logo">
    <a routerLink="/auth/login">
      <i class="las la-arrow-left"></i>
      {{ 'USERS.SIGNIN' | translate }}
    </a>
  </nav>

  <div class="content-wrapper">
    <!-- de -->
    <article class="content" *ngIf="translateService.currentLang === 'de'; else enBlock">
      <h2 class="text-center">{{ 'USERS.PRIVACY_POLICY' | translate }}</h2>
      <p class="text-center mb-4">Gültig ab: {{ effectiveDate }}</p>

      <h3>1. Von uns erfasste Daten</h3>
      <ul>
        <li>Vollständiger Name</li>
        <li>E‑Mail‑Adresse</li>
        <li>Telefonnummer</li>
        <li>Rechnungsadresse</li>
        <li>Angaben zur Immobilie (z. B. Mietverträge)</li>
        <li>Bankverbindung (für Immobilienbesitzer)</li>
        <li>Zahlungsdaten (über FinAPI)</li>
        <li>IP‑Adresse und Nutzungsdaten</li>
      </ul>

      <h3>2. Zweck der Datenerhebung</h3>
      <ul>
        <li>Dienstleistungen für Immobilienvermietung & Versorgungsabrechnung bereitstellen</li>
        <li>Sichere Zahlungsabwicklung über FinAPI ermöglichen</li>
        <li>Kommunikation mit Nutzern aufrechterhalten</li>
        <li>Gesetzliche und vertragliche Pflichten erfüllen</li>
        <li>Leistung & Usability der Plattform verbessern</li>
      </ul>

      <h3>3. Rechtsgrundlage für die Verarbeitung</h3>
      <ul>
        <li>Ihre Einwilligung</li>
        <li>Erfüllung eines Vertrags</li>
        <li>Einhaltung gesetzlicher Verpflichtungen</li>
        <li>Berechtigte Interessen unseres Unternehmens</li>
      </ul>

      <h3>4. Weitergabe von Daten</h3>
      <ul>
        <li>FinAPI GmbH zur sicheren Zahlungsabwicklung</li>
        <li>Hosting- & Infrastrukturprovider</li>
        <li>Rechts- oder Aufsichtsbehörden, wenn erforderlich</li>
      </ul>
      <p>Wir verkaufen oder vermieten Ihre personenbezogenen Daten niemals.</p>

      <h3>5. Datensicherheit</h3>
      <p>Wir verwenden branchenübliche Sicherheitsmaßnahmen wie Verschlüsselung, sichere APIs und Zugriffskontrollen.</p>

      <h3>6. Datenspeicherung</h3>
      <p>Daten werden nur so lange gespeichert, wie es für die genannten Zwecke nötig oder gesetzlich vorgeschrieben ist.</p>

      <h3>7. Ihre Rechte</h3>
      <ul>
        <li>Zugriff auf Ihre Daten</li>
        <li>Berichtigung unrichtiger Daten</li>
        <li>Löschung Ihrer Daten („Recht auf Vergessenwerden“)</li>
        <li>Einschränkung oder Widerspruch der Verarbeitung</li>
        <li>Datenübertragbarkeit</li>
        <li>Widerruf der Einwilligung</li>
      </ul>
      <p>Anfragen → privacy&#64;insight360.tech</p>

      <h3>8. Cookies</h3>
      <p>Unsere Plattform kann Cookies nutzen. Sie können diese im Browser verwalten.</p>

      <h3>9. Änderungen dieser Richtlinie</h3>
      <p>Updates werden hier mit neuem Gültigkeitsdatum veröffentlicht.</p>

      <h3>10. Kontakt</h3>
      <address>
        Insight360 GmbH
        Bernhard-Otte-Straße 12 46395 Bocholt
        E-Mail: info&#64;insight360.tech
      </address>
    </article>

    <!-- en -->
    <ng-template #enBlock>
      <article class="content">
        <h2 class="text-center">{{ 'USERS.PRIVACY_POLICY' | translate }}</h2>
        <p class="text-center mb-4">Effective Date: {{ effectiveDate }}</p>

        <h3>1. Information We Collect</h3>
        <ul>
          <li>Full name</li>
          <li>Email address</li>
          <li>Phone number</li>
          <li>Billing address</li>
          <li>Property details (e.g., rental agreements)</li>
          <li>Bank account information (for property owners)</li>
          <li>Payment data (via FinAPI)</li>
          <li>IP address and usage data</li>
        </ul>

        <h3>2. Purpose of Data Collection</h3>
        <ul>
          <li>Provide property rental and utility billing services</li>
          <li>Enable secure payment processing through FinAPI</li>
          <li>Maintain communication with users</li>
          <li>Fulfill legal and contractual obligations</li>
          <li>Improve platform performance and usability</li>
        </ul>

        <h3>3. Legal Basis for Processing</h3>
        <ul>
          <li>Your consent</li>
          <li>Performance of a contract</li>
          <li>Compliance with legal obligations</li>
          <li>Legitimate interests of our business</li>
        </ul>

        <h3>4. Sharing of Data</h3>
        <ul>
          <li>FinAPI GmbH for secure payment initiation</li>
          <li>Hosting and infrastructure providers</li>
          <li>Legal or regulatory authorities when required</li>
        </ul>
        <p>We never sell or rent your personal data.</p>

        <h3>5. Data Security</h3>
        <p>We use industry-standard security measures, including encryption, secure APIs, and access controls.</p>

        <h3>6. Data Retention</h3>
        <p>Your data is retained only as long as necessary for the purposes described or as required by law.</p>

        <h3>7. Your Rights</h3>
        <ul>
          <li>Access your data</li>
          <li>Correct inaccurate data</li>
          <li>Delete your data ("right to be forgotten")</li>
          <li>Restrict or object to processing</li>
          <li>Data portability</li>
          <li>Withdraw consent</li>
        </ul>
        <p>Requests → privacy&#64;insight360.tech</p>

        <h3>8. Cookies</h3>
        <p>Our platform may use cookies to improve user experience. You can manage cookies through your browser settings.</p>

        <h3>9. Changes to This Policy</h3>
        <p>We may update this policy. Changes will be posted on this page with a revised effective date.</p>

        <h3>10. Contact Us</h3>
        <address>
          Insight360 GmbH
          Bernhard-Otte-Straße 12 46395 Bocholt
          E-Mail: info&#64;insight360.tech
        </address>
      </article>
    </ng-template>
  </div>
</div>
